var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticStyle:{"padding":"10px 0 10px 0","background-color":"#ffffff"}},[_c('el-col',{staticStyle:{"display":"flex","justify-content":"flex-start","padding":"0 10px"},attrs:{"span":24}},[_c('span',{staticClass:"search-text",staticStyle:{"z-index":"11"}},[_vm._v("My Account")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41529912","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/components/profileImageSection.vue
// module id = null
// module chunks = 